/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Definitions_Tenant_Admin_LabelInputs */

const es_tyc_definitions_tenant_admin_label = /** @type {(inputs: Tyc_Definitions_Tenant_Admin_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrador de Inquilino`)
};

const en_tyc_definitions_tenant_admin_label = /** @type {(inputs: Tyc_Definitions_Tenant_Admin_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tenant Administrator`)
};

/**
* | output |
* | --- |
* | "Tenant Administrator" |
*
* @param {Tyc_Definitions_Tenant_Admin_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_definitions_tenant_admin_label = /** @type {((inputs?: Tyc_Definitions_Tenant_Admin_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Definitions_Tenant_Admin_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_definitions_tenant_admin_label(inputs)
	return en_tyc_definitions_tenant_admin_label(inputs)
});
export { tyc_definitions_tenant_admin_label as "tyc.definitions.tenant_admin_label" }